'use client';
import dynamic from 'next/dynamic';
import { Suspense } from 'react';

const ChatLayoutDynamic = dynamic(() =>
	import('./dynamicContent').then((mod) => mod.ChatAside)
);

export const ChatAside = () => (
	<Suspense fallback={<div />}>
		<ChatLayoutDynamic />
	</Suspense>
);
